export default "__VITE_ASSET__BFvzgeaH__"